/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  const handleMonogramMarkup = () => {
    const MONOGRAM_PRICE = 16;

    // Stub selectors
    const checkbox = document.querySelector('.pplrcheckbox');
    const button = document.querySelector('.product__submit__item button[name="add"] .btn__price');

    // Bail if the expected elements aren't present
    if (checkbox && button) {

      // Read the original price from the button text
      const basePrice = parseFloat(
        button.textContent.match(/\$([\d,.]+)/)[1].replace(/,/g, '')
      );

      function updateAddToCartPrice() {
        const total = basePrice + (checkbox.checked ? MONOGRAM_PRICE : 0);

        button.textContent = button.textContent.replace(
          /\$[\d,.]+/,
          `$${total.toFixed(2)}`
        );
      }

      checkbox.addEventListener('change', updateAddToCartPrice);
      updateAddToCartPrice();
    }
  };
  window.setTimeout(handleMonogramMarkup, 750);

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
